import apiFactory, { csv, getCSV, getZip, pdf, zip } from '@scoir/api'
import { clearSignedInApp } from '@scoir/redirects'

import { removeBearerToken } from './bearer'

const userLogin = '/signin'

export const getIsLocalPortDevMode = () => {
  const isInsecure = window.location.protocol === 'http:'
  const isLocalPortDevMode = import.meta.env.DEV && isInsecure
  return isLocalPortDevMode
}

export const getUnauthedFallbackUrl = () => {
  const devLogin = `${import.meta.env.BASE_URL}/login`
  const loginPage = getIsLocalPortDevMode() ? devLogin : userLogin
  return loginPage
}

/**
 * If you are not logged in, and try to do an api call using the old bearer-token,
 * this fn will be called to determine where to redirect the user to.
 * We also remove the unusable bearer-token at the same time
 * @returns {string} - The url to redirect to if the user is not logged in
 */
export const removeBearerTokenAndGetUnauthedFallbackUrl = () => {
  removeBearerToken()
  clearSignedInApp('admissions')
  return getUnauthedFallbackUrl()
}

export default apiFactory(removeBearerTokenAndGetUnauthedFallbackUrl)

export { pdf, getCSV, getZip, csv, zip }
